import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomLink from '@gc-npm/components.custom-link';
import { actions as recomendatorActions } from '@/reducers/recomendator';
import IconGlyph from '@gc-npm/components.icon-glyph';
import Switch, { SWITCH_TYPE } from '@/components/cms-switch';
import TextInfo, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_HEADING_LEVEL,
  TEXT_KIND,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import { COLORS } from '@gc-npm/utils.enums.colors';

const WIDTH_BUTTON_NORMAL = '78px';
const HEIGTH_BUTTON_NORMAL = '36px';
const WIDTH_BUTTON_TV = '84px';

export const RecomendererSection = ({
  info,
  itemSelected,
  type,
  cssLoading,
  tvNotAllowed,
}) => {
  const dispatch = useDispatch();
  const [sectionBlocked, setSectionBlocked] = useState(false);

 
  if (!info) {
    return null;
  }

  const onClick = (id) => {
    const data = {
      [type]: id,
    };
    dispatch(
      recomendatorActions.selectRecomendator({
        data,
      }),
    );
  };

  const notShowItemsNotAllowed = tvNotAllowed && type === 'tvChannels';
  const taggingInfoButton = {
    componentContent: '',
    componentName: 'cards-recomendador',
    componentProduct: '',
    componentVariation: 'All',
  };
  const taggingInfoSwitch = {
    componentContent: '',
    componentName: 'switch-recomendador',
    componentProduct: '',
    componentVariation: 'All',
  };
  const onclickSwitch = () => {
    setSectionBlocked(!sectionBlocked);
    dispatch(recomendatorActions.resetSelectedTv());
  };

  const textSwitch = {
    align: TEXT_ALIGN.LEFT,
    color: TEXT_COLOR.GREY6,
    fontType: TEXT_FONT_WEIGHT.REGULAR,
    kind: TEXT_KIND.PARAGRAPH,
    size: TEXT_SIZE.CAPTION,
    text: info?.additionalActionsTitle,
  };

  return (
    <div className="RecomendererSection">
      <div className={`recomTitle ${cssLoading}`}>
        <TextInfo
          text={info.title}
          size={TEXT_SIZE.T7}
          color={TEXT_COLOR.GREY6}
          fontType={TEXT_FONT_WEIGHT.BOLD}
          kind={TEXT_KIND.HEADING}
          level={TEXT_HEADING_LEVEL.H2}
          align={TEXT_ALIGN.LEFT}
        />
      </div>

      <div className={`buttons ${type === 'tvChannels' ? 'typeTv' : ''}`}>
        {info?.filters.map((item) => {
          let isSelected = false;
          if (typeof itemSelected === 'string') {
            if (itemSelected === item.id) {
              isSelected = true;
            }
          } else if(typeof itemSelected === 'number'){
             if (`${itemSelected}` === `${item.id}`) {
              isSelected = true;
            }
          }else if (Array.isArray(itemSelected)) {
            if (itemSelected.includes(item.id)) {
              isSelected = true;
            }
          }
          if (item?.permanentHide) {
            return null;
          }
          if (!item.show) {
            return null;
          }
          return (
            <div
              key={item.id}
              className={`item ${cssLoading} ${sectionBlocked ? 'disabled' : ''}`}
            >
              <CustomLink
                href={item?.href}
                ariaLabel={item?.label}
                onClick={() => onClick(item.id)}
                disabled={sectionBlocked}
                taggingInfo={{
                  ...taggingInfoButton,
                  componentProduct: item?.label,
                  componentContent: isSelected ? 'quitar' : 'añadir',
                }}
              >
                <div
                  className={`buttonContainer ${isSelected ? 'selected' : ''} ${type === 'tvChannels' ? 'typeTv' : ''}`}
                >
                  {item?.icon && <IconGlyph {...item?.icon} />}
                  <TextInfo
                    text={item?.label}
                    size={TEXT_SIZE.CAPTION}
                    color={
                      isSelected && !item?.icon
                        ? TEXT_COLOR.BLUE_HIGH
                        : TEXT_COLOR.MOVISTAR_BLACK
                    }
                    fontType={TEXT_FONT_WEIGHT.LIGHT}
                    align={TEXT_ALIGN.LEFT}
                  />
                </div>
              </CustomLink>
            </div>
          );
        })}
      </div>
      {notShowItemsNotAllowed && (
        <div className="tvNotAllowed">
          <IconGlyph id="informacion" height={34} width={34} kind="M" />
          <div className="text">
            <TextInfo
              text="Para seleccionar contenidos de TV necesitas elegir Fibra 600 Mb o 1 Gb"
              size={TEXT_SIZE.BODY1}
              color={TEXT_COLOR.GREY6}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
              align={TEXT_ALIGN.LEFT}
            />
          </div>
        </div>
      )}
      {!notShowItemsNotAllowed && (
        <div className={`subTitle ${cssLoading}`}>
          <TextInfo
            text={info.subTitle}
            size={TEXT_SIZE.CAPTION}
            color={TEXT_COLOR.GREY5}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
            align={TEXT_ALIGN.LEFT}
          />
        </div>
      )}

      {info?.additionalActionsTitle && !notShowItemsNotAllowed && (
        <div className={`additionalActions ${cssLoading}`}>
          <Switch
            cmsSwitchProps={{
              onChange: onclickSwitch,
              selectedState: sectionBlocked,
              id: 'switch-tv',
              type: SWITCH_TYPE.PRIMARY,
              disabled: cssLoading,
              taggingInfo: { taggingInfoSwitch },
            }}
            cms-atom-text-1={{ ...textSwitch }}
          />

        </div>
      )}
      <style jsx>
        {`
        .RecomendererSection {
          max-width: 33%;
          width: calc(33% - 0.5rem);
          display: flex;
          flex-direction: column;
          align-items: left;
          gap: 0.5rem;
        }
 

 
        .RecomendererSection .buttons {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: center;
          gap: 0.75rem;
          max-width: 430px;
        }
       
 
        .RecomendererSection .buttons .skeleton {
          width: auto;
        }
 
        .RecomendererSection .buttons .item .buttonContainer {
          width: ${WIDTH_BUTTON_NORMAL};
          height: ${HEIGTH_BUTTON_NORMAL};
          padding: 0.4rem;
          border: 1px solid ${COLORS.grey300};
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          align-content: center;
          align-items: center;
          justify-content: space-evenly
        }
 
        .RecomendererSection .buttons .item .buttonContainer.selected {
          border: 2px solid ${COLORS.blueHigh};
          background-color: ${COLORS.blue200};
        }
 
        .RecomendererSection .buttons .item .buttonContainer.typeTv {
          border-radius: 8px;
          width: ${WIDTH_BUTTON_TV};
          height: ${WIDTH_BUTTON_TV};
          display: flex;
          align-items: center;
          gap: 0.5rem;
          justify-content: center;
        }
 
        .RecomendererSection .buttons .item.disabled {
          opacity: 40%;
        }
 
        .RecomendererSection
          .buttons
          .item:not(.disabled)
          .buttonContainer:not(.selected):hover {
          border: 1px solid ${COLORS.grey500};
          background-color: ${COLORS.grey100};
        }
 
        .RecomendererSection .tvNotAllowed {
          width: 100%;
          background-color: ${COLORS.grey100};
          display: flex;
          flex-direction: row;
          border-radius: 8px;
          padding: 1rem;
          align-items: flex-start;
          gap: 0.5rem;
        }
 
        .RecomendererSection .additionalActions {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 0.5rem;
        }
   @media (max-width: 1293px) {
           .RecomendererSection .buttons .item .buttonContainer.typeTv {
           width: 80px !important;
            height: 80px !important;
          }
        }
        @media (max-width: 1050px) {
          .RecomendererSection {
            min-width: 500px;
            max-width: calc(50% - 0.5rem);
          }
        }
        
 
        @media screen and (max-width: 768px) {
          .RecomendererSection {
            min-width: 100%;
            max-width: 100%;
          }
 
          .RecomendererSection .buttons {
            gap: 0.75rem;
           
          }
       
        }
         @media screen and (max-width: 429px) {
          .RecomendererSection {
            min-width: 100%;
            max-width: 100%;
          }
 .RecomendererSection .buttons.typeTv {
          justify-content: center;
        }
         
          .RecomendererSection .buttons {
            gap: 0.6rem;
          }
 
          .RecomendererSection .buttons .item .buttonContainer.typeTv {
            width: 80px !important;
            height: 80px !important;
          }
        }
 
        @media (max-width: 390px) {
          .RecomendererSection .buttons {
            gap: 0.5rem;
          }
 
          .RecomendererSection .buttons .item .buttonContainer.typeTv {
            width: 75px !important;
            height: 75px !important;
          }
        }
 
     
 
     
        :global(.buttonContainer.typeTv .text-size--caption) {
          font-size: 0.75rem;
        }
      `}
      </style>
    </div>
  );
};

export default RecomendererSection;
